import { useEffect } from 'react';
import { datadogRum } from '@datadog/browser-rum';

import { TaskLike } from '../../MemberOperator.interfaces';

export default function useMemberOperatorDatadog(task: TaskLike | undefined, trackViewOnMount = true) {
    useEffect(() => {
        if (task && trackViewOnMount) {
            datadogRum.setGlobalContextProperty('operator_task_id', task.id);
            datadogRum.setGlobalContextProperty('operator_task_type', task.task_type);
            datadogRum.setGlobalContextProperty('operator_task_status', task.status);
            datadogRum.setGlobalContextProperty('operator_task_template', task.task_template.name);

            datadogRum.addAction('Operator Task View', {
                operator_task_id: task.id,
                operator_task_type: task.task_type,
                operator_task_status: task.status,
                operator_task_template: task.task_template.name,
            });

            return () => {
                datadogRum.removeGlobalContextProperty('operator_task_id');
                datadogRum.removeGlobalContextProperty('operator_task_type');
                datadogRum.removeGlobalContextProperty('operator_task_status');
                datadogRum.removeGlobalContextProperty('operator_task_template');
            };
        }
    }, [task?.id, task?.status, trackViewOnMount]);
}
